import request from './request'
import store from '@/store.js'

const baseUrl = () => store.getters['getBaseUrl']
const api = {
  getInitialData () {
    return request({
      url: baseUrl() + '/api/candidator/initialRequest',
      method: 'get'
    })
  },

  getDSB () {
    return request({
      url: baseUrl() + '/api/candidator/getDsb',
      method: 'get'
    })
  },

  getQuestions () {
    return request({
      url: baseUrl() + '/api/candidator/getQuestions',
      method: 'get'
    })
  },

  getCandidateCount () {
    return request({
      url: baseUrl() + '/api/candidator/getCandidateCount',
      method: 'get'
    })
  },

  sendRejectionMail (candidateUuid) {
    return request({
      url: baseUrl() + '/api/candidator/SendRejection',
      method: 'post',
      data: {
        uuid: candidateUuid
      }
    })
  },

  uploadFile (file, candidateUuid, questionKey) {
    /*  IMPORTANT
        Use FormData.append() only!
        Do not use FormData.set() or anything else on FormData
        IE 11 and Safari 10 do not support anything but append()
    */
    var formData = new FormData()
    formData.append('upload', file)
    formData.append('uuid', candidateUuid)
    formData.append('question_key', questionKey)

    return request({
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      url: baseUrl() + '/api/candidator/upsertFile',
      method: 'post'
    })
  },

  getFile (candidateUuid, questionKey) {
    const params = '?candidate=' + candidateUuid + '&question=' + questionKey
    const url = baseUrl() + '/api/candidator/getFile' + params
    window.open(url)
  },

  deleteFile (candidateUuid, questionKey) {
    return request({
      data: {
        uuid: candidateUuid,
        question_key: questionKey
      },
      url: baseUrl() + '/api/candidator/deleteFile',
      method: 'post'
    })
  },

  getCandidates (status) {
    return request({
      url: baseUrl() + '/api/candidator/getCandidates',
      method: 'post',
      data: {
        status: status
      }
    })
  },

  createCandidate (candidateObj) {
    return request({
      data: candidateObj,
      url: baseUrl() + '/api/candidator/createCandidate',
      method: 'post'
    })
  },

  upsertCandidate (candidateObj) {
    return request({
      data: candidateObj,
      url: baseUrl() + '/api/candidator/upsertCandidate',
      method: 'post'
    })
  },

  deleteCandidate (candidateUuid) {
    return request({
      data: {
        uuid: candidateUuid
      },
      url: baseUrl() + '/api/candidator/deleteCandidate',
      method: 'post'
    })
  },

  getPages () {
    return request({
      url: baseUrl() + '/api/candidator/getPages',
      method: 'get'
    })
  },

  getCategories () {
    return request({
      url: baseUrl() + '/api/candidator/getCategories',
      method: 'get'
    })
  },

  exportCandidate (payload) {
    return request({
      url: baseUrl() + '/api/candidator/exportCandidate',
      method: 'post',
      data: payload
    })
  },

  createEmployee (candidateObj) {
    return request({
      url: baseUrl() + '/api/candidator/createEmployee',
      method: 'post',
      data: candidateObj
    })
  }
}

export default api
